import React from "react";
import Styled, { css } from 'styled-components'
import { FlexBoxPropsType, FlexProps } from "./types";
import Box from "..";
import { checkFlexGapSupported } from "./checkFlexGapSupported";

const computeValue = (value: number | string) => {
    if(typeof value === "number") {
        return `${value || 0}px`;
    }
    return value;
}

export const flexGap = (gap: number | string, column: boolean) => {
    if (checkFlexGapSupported()) {
        return css`
        gap: ${computeValue(gap)};
      `;
    }
    return flexGapPolyfill(gap, column);
};

export const flexGapPolyfill = (gap: number | string, column: boolean) => {
    return css`
        >div, >span, >button {
            ${column ? `margin-bottom: ${computeValue(gap)};` : `margin-right: ${computeValue(gap)};`}
            &:last-child {
                ${column ? `margin-bottom: 0px;` : `margin-right: 0px;`}
            }
        }
    `;
};

const ContainerDiv = Styled(Box) <FlexBoxPropsType>`
    display: flex;
    flex-direction: ${props => props.column ? FlexProps.FlexDirection.COLUMN : FlexProps.FlexDirection.ROW};
    justify-content: ${props => props.justifyContent || (props.spaceBetween ? FlexProps.JustifyContent.SPACE_BETWEEN : FlexProps.JustifyContent.FLEX_START)};
    align-items: ${props => props.alignItems || (props.alignStart ? FlexProps.AlignItems.FLEX_START : FlexProps.AlignItems.CENTER)};
    flex-wrap: ${props => props.flexWrap || (props?.noWrap ? FlexProps.FlexWrap.NOWRAP : FlexProps.FlexWrap.WRAP)};
    // gap: ${props => props.gap ? `${props.gap}px` : '0px'};
    ${props => props.center && `
        justify-content: center;
    `}
    ${props => props.gap && flexGap(props.gap, props.column)};
    ${props => props.flexDirection && `
        flex-direction: ${props.flexDirection};
    `};
`;

const FlexBox: React.FC<FlexBoxPropsType> = ({ children, dataTestId, ...props }) => {
    return <ContainerDiv data-test-id={dataTestId} data-test-class="sui-flex-container" {...props}>{children}</ContainerDiv>;
};


export default FlexBox;